// src/stores/cauSessionStore.js
import { defineStore } from "pinia";
import { CauSessionApi } from "@/services/cauSessionService";

export const useCauSessionStore = defineStore("cauSession", {
  state: () => ({
    activeSession: null,
    hasActive: false,

    isLoadingActive: false,
    activeError: null,

    isSubmittingOpen: false,
    isSubmittingClose: false,
    submitError: null,

    // ⭐ Lịch sử
    history: [],
    isLoadingHistory: false,
    historyError: null,
  }),

  actions: {
    async fetchActiveForDriver(taiXeId) {
      this.isLoadingActive = true;
      this.activeError = null;
      try {
        const res = await CauSessionApi.getActiveByDriver(taiXeId);
        this.activeSession = res || null;
        this.hasActive = !!res;
      } catch (e) {
        console.error("[cauSessionStore] fetchActiveForDriver", e);
        this.activeError = "Không tải được phiên cẩu hiện tại.";
        this.activeSession = null;
        this.hasActive = false;
      } finally {
        this.isLoadingActive = false;
      }
    },

    // ⭐ thêm action lịch sử
    async fetchHistoryForDriver(taiXeId) {
      this.isLoadingHistory = true;
      this.historyError = null;
      try {
        const res = await CauSessionApi.historyByDriver(taiXeId);
        this.history = Array.isArray(res) ? res : [];
      } catch (e) {
        console.error("[cauSessionStore] fetchHistoryForDriver", e);
        this.historyError = "Không tải được lịch sử cẩu.";
        this.history = [];
      } finally {
        this.isLoadingHistory = false;
      }
    },

    async openCau(taiXeId, payload) {
      this.isSubmittingOpen = true;
      this.submitError = null;
      try {
        const res = await CauSessionApi.startSession(taiXeId, payload);
        this.activeSession = res;
        this.hasActive = true;
        return res;
      } catch (e) {
        console.error("[cauSessionStore] openCau", e);
        this.submitError = "Không mở được phiên cẩu. Vui lòng thử lại.";
        throw e;
      } finally {
        this.isSubmittingOpen = false;
      }
    },

    async closeCau(taiXeId, sessionId, payload) {
      this.isSubmittingClose = true;
      this.submitError = null;
      try {
        const res = await CauSessionApi.endSession(taiXeId, sessionId, payload);
        this.activeSession = null;
        this.hasActive = false;
        return res;
      } catch (e) {
        console.error("[cauSessionStore] closeCau", e);
        this.submitError = "Không đóng được phiên cẩu. Vui lòng thử lại.";
        throw e;
      } finally {
        this.isSubmittingClose = false;
      }
    },
  },
});
